import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'

// Global error handler to suppress known non-application errors
window.addEventListener('error', (event) => {
  const errorMessage = event.error?.message || event.message || '';
  
  // Suppress bootstrap autofill overlay errors (browser extension)
  if (errorMessage.includes('getComputedStyle') && 
      errorMessage.includes('parameter 1 is not of type \'Element\'')) {
    console.debug('Suppressed browser extension error:', errorMessage);
    event.preventDefault();
    return false;
  }
  
  // Suppress bootstrap autofill overlay errors (different variant)
  if (event.filename?.includes('bootstrap-autofill-overlay.js')) {
    console.debug('Suppressed bootstrap autofill overlay error');
    event.preventDefault();
    return false;
  }
});

// Global unhandled promise rejection handler for WebSocket errors
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.message || event.reason || '';
  
  // Suppress Vite WebSocket connection errors during development
  if (typeof reason === 'string' && reason.includes('WebSocket closed without opened')) {
    console.debug('Suppressed Vite WebSocket error during development');
    event.preventDefault();
    return false;
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)